import React from 'react';
import { motion } from 'motion/react';
import { formatNumberWithCommas } from '../../utils/numbers';
import Pill from './Pill';
import styles from './styles/data-card.module.scss';

function DataCard({ amount, title, subtitle, dataType, percentage, selected, onClick, isCurrency = false, isPercentage = true, isTitle = true }) {
    const formatted = amount ? (isCurrency ? `$${formatNumberWithCommas(amount, true)}` : formatNumberWithCommas(amount)) : '0';
    return (
        <motion.button whileHover={{ scale: 1.05 }} className={`${styles.dataCard} ${selected ? styles.selected : ''}`} onClick={onClick}>
            <p className={`${styles.title} ${selected ? styles.selected : ''}`}>{title}</p>
            <p className={`${styles.subtitle} ${selected ? styles.selected : ''}`}>{subtitle}</p>
            <div className={styles.amountContainer}>
                <p className={`${styles.amount} ${selected ? styles.selected : ''}`}>{formatted}</p>
                <p className={`${styles.label} ${selected ? styles.selected : ''}`}>{dataType}</p>
            </div>
            {percentage ? <Pill color="#2b9943" text={`${isPercentage ? `${percentage}%` : `${percentage}`} ${isTitle ? title : ''}`} /> : null}
        </motion.button>
    );
}

export default DataCard;
